/**
 * AppLayout — the staff app shell (UI/UX refresh, Phase 2).
 *
 * A route-level layout: renders the navy Sidebar + slim Topbar around an
 * <Outlet/> for the active screen. Wraps the authenticated staff routes in
 * App.tsx (inside ProtectedRoute, so it never renders for signed-out users).
 *
 * Pages still mount the now-inert <TopNavBar/> / <Footer/> shims until
 * Phase 3 strips them during the per-screen restyle.
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function AppLayout() {
  // Desktop rail collapse, and the mobile off-canvas drawer — independent.
  const [collapsed, setCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
        mobileOpen={mobileNavOpen}
        onCloseMobile={() => setMobileNavOpen(false)}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onOpenMobileNav={() => setMobileNavOpen(true)} />
        <Outlet />
      </div>
    </div>
  );
}
